import React from 'react';
import {
  FDIcon, FDLozenge, FDStack, FDTooltip,
} from '@facet-wealth/design';
import PropTypes from 'prop-types';
import fr from 'facet-rest';

const getLozengeColorFromStatus = (status) => {
  switch (status) {
    case 'Pending':
      return 'info';
    case 'Current':
      return 'success';
    default:
      return 'info';
  }
};

export const PaymentDetailStatus = ({ resource }) => {
  const status = resource.attr('status');
  const tooltipText = resource.attr('statusTooltipText');
  const color = getLozengeColorFromStatus(status);
  if (!status) {
    return null;
  }
  if (tooltipText) {
    return (
      <FDStack spacing={1} alignItems={'center'}>
        <FDLozenge label={status} color={color} />
        <FDTooltip
          title={tooltipText}
          placement="top"
        >
          <FDIcon icon={'info'} color={color} size={'sm'} />
        </FDTooltip>
      </FDStack>
    );
  }
  return (
    <FDLozenge label={status} color={color} />
  );
};

PaymentDetailStatus.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};
